import type { ReactElement } from "react";

type IconProps = { className?: string; isDarkTheme?: boolean };

const base = "h-full w-full";

export function Icon({ name, className }: { name: string; className?: string }) {
  const map: Record<string, ReactElement> = {
    factory: (
      <path d="M2 20h20M4 20V9l5 3V9l5 3V9l5 3v8M9 13v3m4-3v3m4-3v3M6 9V6l2-2" />
    ),
    globe: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
      </>
    ),
    leaf: (
      <path d="M11 20A7 7 0 0 1 4 13c0-5 5-9 16-9 0 9-4 16-9 16ZM4 21c4-5 7-8 12-10" />
    ),
    cube: (
      <>
        <path d="M21 8l-9-5-9 5 9 5 9-5Z" />
        <path d="M3 8v8l9 5 9-5V8M12 13v8" />
      </>
    ),
  };
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className ?? base}
    >
      {map[name]}
    </svg>
  );
}

export function Logo({ className, isDarkTheme }: IconProps) {
  return (
    <div className={className}>
      <div className="flex items-baseline gap-1 leading-none">
        <span className={`text-2xl font-extrabold tracking-tight ${isDarkTheme ? 'text-white' : 'text-teal-600'}`}>
          technostud
        </span>
        <span className="h-2 w-2 rounded-full bg-cyan-400 shadow-[0_0_8px_2px_rgba(34,211,238,0.7)]" />
      </div>
      <div className="mt-0.5 flex items-center gap-2">
        <span className={`text-[0.6rem] font-semibold uppercase tracking-[0.45em] ${isDarkTheme ? 'text-slate-400' : 'text-slate-500'}`}>
          engineering
        </span>
        <span className="h-px flex-1 bg-gradient-to-r from-teal-400/60 to-transparent" />
      </div>
    </div>
  );
}
